export default function formatSlug(
  link: string,
  produce: boolean,
  consume: boolean
) {
  var slug;
  if (!!produce && !consume) {
    slug = link.trim().split(" ").join("-");
  }
  if (!!consume && !produce) {
    slug = link.trim().replace(/-/g, " ").concat("?");
  } else if (!produce && !consume) {
    slug = link.replace(/-/g, " ");
  }
  return slug;
}
